import i18n from "@/plugins/vue-i18n";

const Dashboard = () =>
  import(/* webpackChunkName: "dashboard" */ "@/views/advert/dashboard/DashboardPage.vue");

const dashboard = [
  {
    path: "/dashboard",
    name: "Dashboard",
    component: Dashboard,
    meta: {
      title: i18n.t("title.dashboard"),
    },
  },
];

export default dashboard;
